import React from "react";
import { STATUS_META } from "@/lib/constants";
import { cn } from "@/lib/utils";

export function StatusBadge({ status, className, testId }) {
  const meta = STATUS_META[status] || STATUS_META.draft;
  return (
    <span
      data-testid={testId}
      className={cn(
        "inline-flex items-center gap-2 rounded-full border px-3 py-1 text-sm font-semibold",
        meta.badge,
        className
      )}
    >
      <span className={cn("h-2.5 w-2.5 rounded-full", meta.dot)} />
      {meta.label}
    </span>
  );
}

export function ProgressBar({ value, status }) {
  const meta = STATUS_META[status] || STATUS_META.draft;
  return (
    <div className="h-2.5 w-full overflow-hidden rounded-full bg-slate-100">
      <div
        className={cn("h-full rounded-full transition-all duration-500", meta.bar)}
        style={{ width: `${Math.max(4, value || 0)}%` }}
      />
    </div>
  );
}
